import { defineMessages } from "react-intl"

export const ADD_ITEM_BUNDLE_MESSAGES = defineMessages({
    modal_add_item_title: {
        id: "product.components.product_search_modal.modal_add_item_title",
        defaultMessage: "Add a product or service"
    },
    modal_configure_item_title: {
        id: "product.components.product_search_modal.modal_configure_item_title",
        defaultMessage: "Select variant:"
    },
    modal_back_btn: {
        id: "product.components.product_search_modal.modal_back_btn",
        defaultMessage: "Back"
    },
    modal_close_btn: {
        id: "product.components.product_search_modal.modal_close_btn",
        defaultMessage: "Close"
    },
    modal_save_btn: {
        id: "product.components.product_search_modal.modal_save_btn",
        defaultMessage: "Save"
    },
    modal_add_variant_btn: {
        id: "product.components.product_search_modal.modal_add_variant_btn",
        defaultMessage: "Add variant"
    },
})


// WEBPACK FOOTER //
// ./src/utils/bundle/messages.ts